import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

export interface LinkMenuItemProps {
  /** The text to display in the menu item */
  text: string;
  /** The path/URL to navigate to */
  to: string;
  /** Optional click handler for additional actions */
  onClick?: () => void;
  /** Custom styles for the MenuItem */
  sx?: SxProps<Theme>;
  /** Custom styles for the Typography */
  typographySx?: SxProps<Theme>;
  /** Text alignment for the Typography */
  textAlign?: 'left' | 'center' | 'right';
}

const defaultLinkStyles: React.CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  width: '100%',
  display: 'block'
};

export const LinkMenuItem: React.FC<LinkMenuItemProps> = ({
  text,
  to,
  onClick,
  sx,
  typographySx,
  textAlign = 'left',
}) => {
  return (
    <MenuItem sx={sx}>
      <Link
        to={to}
        onClick={onClick}
        style={defaultLinkStyles}
      >
        <Typography component="span" textAlign={textAlign} sx={typographySx}>
          {text}
        </Typography>
      </Link>
    </MenuItem>
  );
};

export default LinkMenuItem;
